import { openBlobFile } from "@/utils/utils";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { competitionApi } from "../../../modules/competition/api";
import {
  ChinaCompetitionResultExportRequest,
  ChinaCompetitionResultFilterPageRequest,
  SloveniaCompetitionResultExportRequest,
  SloveniaCompetitionResultFilterPageRequest,
} from "../../../modules/competition/types";

export const COMPETITION_QUERY_KEYS = {
  filterChinaCompetitionResults: (filter?: ChinaCompetitionResultFilterPageRequest) =>
    filter ? ["filterChinaCompetitionResults", filter] : ["filterChinaCompetitionResults"],
  downloadChinaCompetitionResultsExport: () => ["downloadChinaCompetitionResultsExport"],
  filterSloveniaCompetitionResults: (filter?: SloveniaCompetitionResultFilterPageRequest) =>
    filter ? ["filterSloveniaCompetitionResults", filter] : ["filterSloveniaCompetitionResults"],
  downloadSloveniaCompetitionResultsExport: () => ["downloadSloveniaCompetitionResultsExport"],
};

export const useFilterChinaCompetitionResults = (
  payload: ChinaCompetitionResultFilterPageRequest,
  enabled?: boolean,
) => {
  return useQuery({
    queryKey: COMPETITION_QUERY_KEYS.filterChinaCompetitionResults(payload),
    queryFn: async () => {
      const { data } = await competitionApi.filterChinaCompetitionResults(payload);

      return data;
    },
    placeholderData: keepPreviousData,
    enabled,
  });
};

export const useDownloadChinaCompetitionResultsExport = () => {
  return useMutation({
    mutationKey: COMPETITION_QUERY_KEYS.downloadChinaCompetitionResultsExport(),
    mutationFn: async (payload: ChinaCompetitionResultExportRequest) => {
      const response = await competitionApi.downloadChinaCompetitionResultsExport(payload);
      openBlobFile(response, true);

      return response.data;
    },
  });
};

export const useFilterSloveniaCompetitionResults = (
  payload: SloveniaCompetitionResultFilterPageRequest,
  enabled?: boolean,
) => {
  return useQuery({
    queryKey: COMPETITION_QUERY_KEYS.filterSloveniaCompetitionResults(payload),
    queryFn: async () => {
      const { data } = await competitionApi.filterSloveniaCompetitionResults(payload);

      return data;
    },
    placeholderData: keepPreviousData,
    enabled,
  });
};

export const useDownloadSloveniaCompetitionResultsExport = () => {
  return useMutation({
    mutationKey: COMPETITION_QUERY_KEYS.downloadSloveniaCompetitionResultsExport(),
    mutationFn: async (payload: SloveniaCompetitionResultExportRequest) => {
      const response = await competitionApi.downloadSloveniaCompetitionResultsExport(payload);
      openBlobFile(response, true);

      return response.data;
    },
  });
};
